export const labelAndValue = (label: string, value: any, fieldId: string, dataCyPrefix: string,  bold: boolean = false) => {
    return (
        <>
            <div className="col-4 details-label">
                {label}
            </div>
            <div id={fieldId} data-cy={`${dataCyPrefix}-${fieldId}`} className={`col-8 details-value ${bold ? "font-semibold" : ""}`}>
                {value}
            </div>
        </>
    );
}
